import { render, staticRenderFns } from "./TabProfissionais.vue?vue&type=template&id=902be7c0&scoped=true"
import script from "./TabProfissionais.vue?vue&type=script&lang=js"
export * from "./TabProfissionais.vue?vue&type=script&lang=js"
import style0 from "./TabProfissionais.vue?vue&type=style&index=0&id=902be7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902be7c0",
  null
  
)

export default component.exports